import { Location } from './location';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class FavoriteLocation extends AbstractModel {
  @autoserialize
  riderId: number;

  @autoserializeAs(Location)
  location: Location;

  @autoserialize
  label: string;
}
